import { EndgameContent } from '../../models/enums';

export const scarabBaseTypeToContent: Record<string, EndgameContent[]> = {};

export const scarabContentTypes: EndgameContent[] = [];
